@if (heroData) {
    <div #hero
        class="hero-story"
        [ngClass]="{'media-engine': heroData.mediaEngine, 'media-engine-placeholder': !meLoaded}"
    >
        @if (heroData.overlayHeroImage) {
            <div class="overlay-hero-image"
                [finderBgImage]="heroData?.overlayHeroImage"
                [isMobile]="isMobileScreen"
                bgTarget="hero-story">
            </div>
        }

        <div class="media" finderAriaHidden="safari" [ngClass]="{'media-engine': heroData.mediaEngine}">
            @if (!heroData.mediaEngine) {
                <finder-hero-media
                    [picture]="heroData.media"
                    class="picture fit">
                </finder-hero-media>
            }

            @if (heroData.mediaEngine) {
                <finder-media-gallery
                    [version]="mediaEngine.version"
                    [theme]="mediaEngine.theme"
                    [production]="mediaEngine.production"
                    [config]="mediaEngine.config"
                    [ngClass]="{'disabled-fullscreen': disabledFullscreen}"
                    (mediaEngineIsReady)="mediaEngineIsReady($event)"
                    class=theme-{{mediaEngine.theme}}>
                </finder-media-gallery>
            }

            @if (heroData.cta) {
                <div class="cta">
                    <div class="cta-container">
                        <div class="cta-picture">
                            @if (heroData.cta.picture) {
                                <finder-picture
                                    [picture]="heroData.cta.picture"
                                ></finder-picture>
                            }
                        </div>
                        @if (!heroData.cta?.hideVideoPlayCTA) {
                            <div class="cta-mobile">
                                @if (mobile.heading) {
                                    <finder-hero-cta-heading
                                        [ctaData]="mobile.heading"
                                        ctaClass="heading"
                                    ></finder-hero-cta-heading>
                                }

                                @if (mobile.action?.playCTA) {
                                    <finder-hero-cta-action
                                        [ctaData]="mobile.action.playCTA"
                                        ctaClass="cta-action cta-video enter-fullscreen"
                                        (ctaClick)="playbackVideo($event, true)"
                                    ></finder-hero-cta-action>
                                }

                                @if (mobile.action?.detailCTA) {
                                    <finder-hero-cta-action
                                        [ctaData]="mobile.action.detailCTA"
                                        ctaClass="cta-action"
                                    ></finder-hero-cta-action>
                                }

                                @for (action of mobile.action?.ctas; track action) {
                                    <finder-hero-cta-action
                                        [ctaData]="action"
                                        ctaClass="cta-action"
                                    ></finder-hero-cta-action>
                                }
                            </div>
                        }

                        @if (!heroData.cta?.hideVideoPlayCTA) {
                            <div class="cta-desktop">
                                @if (desktop.heading) {
                                    <finder-hero-cta-heading
                                        [ctaData]="desktop.heading"
                                        ctaClass="heading"
                                    ></finder-hero-cta-heading>
                                }

                                @if (desktop.action?.playCTA) {
                                    <finder-hero-cta-action
                                        [ctaData]="desktop.action.playCTA"
                                        ctaClass="cta-action cta-video enter-fullscreen"
                                        (ctaClick)="playbackVideo($event)"
                                    ></finder-hero-cta-action>
                                }

                                @if (desktop.action?.detailCTA) {
                                    <finder-hero-cta-action
                                        [ctaData]="desktop.action.detailCTA"
                                        ctaClass="cta-action"
                                    ></finder-hero-cta-action>
                                }

                                @for (action of desktop.action?.ctas; track action) {
                                    <finder-hero-cta-action
                                        [ctaData]="action"
                                        ctaClass="cta-action"
                                    ></finder-hero-cta-action>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}

